import { CircularProgress, Box, styled, keyframes } from '@mui/material';

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const StyledLoading = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    width: 'auto',
    height: '35px',
    animation: `${pulse} 1.5s ease-in-out infinite`
  }
});

const Loading = ({ m }) => {
  return (
    <StyledLoading>
      <Box
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        m={m || 2}
      >
        <img src="/assets/images/logo_blue.png" alt="" style={{ zIndex: 1 }} />
        {/* Background Track */}
        <CircularProgress
          variant="determinate"
          value={100}
          size={45}
          thickness={2}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-22.5px',
            marginLeft: '-22.5px',
            color: (theme) =>
              theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800]
          }}
        />
        {/* Animated Indicator */}
        <CircularProgress
          size={45}
          thickness={2}
          disableShrink
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-22.5px',
            marginLeft: '-22.5px',
            color: 'primary.main',
            animationDuration: '550ms',
            [`& .MuiCircularProgress-circle`]: {
              strokeLinecap: 'round'
            }
          }}
        />
      </Box>
    </StyledLoading>
  );
};

export default Loading;
